import { render, staticRenderFns } from "./LanguagesMobile.vue?vue&type=template&id=3fa1752a"
import script from "./LanguagesMobile.vue?vue&type=script&lang=js"
export * from "./LanguagesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports